<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area recruit01">
      <img :src="`${resources}img/img-top-sub-title16.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">인재상</div>
        <div class="sub_txt">꿈을 함께 할 최고의 인재를 모집합니다.</div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <h3>한국오션플랫폼은</h3>
      <!-- <div class="sub_cont_txt">
        LS그룹의 경영철학인 ‘LS Partnership’과 <br />스마트하고 혁신적이며
        친환경적인 건설 사업의 가치체계를 지향하는 인재가 모여 만듭니다.
      </div> -->
      <div class="talent">
        <ul class="talent_list">
          <li>
            <p>타인을 존중하고<br />배려하는 사람</p>
          </li>
          <li>
            <p>효율적으로 업무를<br />처리하는 사람</p>
          </li>
          <li>
            <p>원칙을 중요하게<br />생각하는 사람</p>
          </li>
          <li><p>함께 성장하는 사람</p></li>
          <li>
            <p>협력하여 더 큰 가치를<br />만들어 낼 줄 아는 사람</p>
          </li>
          <li>
            <p>책임감을 가지고<br />주도적으로 일하는 사람</p>
          </li>
          <li>
            <p>업무에 몰입하는<br />즐거움을 아는 사람</p>
          </li>
          <li>
            <p>빠르게 판단하고<br />행동으로 옮기는 사람</p>
          </li>
          <li>
            <p>새로운 것에 과감하게<br />도전하는 사람</p>
          </li>
        </ul>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
